import { useDispatch } from "react-redux";
import { itemsSuccess } from "../redux/items";
import { salesSuccess } from "../redux/sales";
import { request } from "../request";
import { Load, snackMessage, openSnack } from "../redux/GlobalStates";
import { creditsSuccess } from "../redux/Credit";
import { expensesSuccess } from "../redux/expenses";
import { customersSuccess } from "../redux/customer";
import { receiptsSuccess } from "../redux/receipts";
import { invoiceSuccess } from "../redux/invoice";
const useRefresh = () => {
  const dispatch = useDispatch();
  const handleRefresh = async (storeId) => {
    dispatch(Load());
    try {
      const res = await request.get(`/auth/refresh?storeId=${storeId}`);
      dispatch(salesSuccess(res.data.sales));
      dispatch(itemsSuccess(res.data.items));
      dispatch(creditsSuccess(res.data.credit));
      dispatch(expensesSuccess(res.data.expenses));
      dispatch(customersSuccess(res.data.customers));
      dispatch(receiptsSuccess(res.data.receipts));
      dispatch(invoiceSuccess(res.data.invoice));
      dispatch(snackMessage("Refreshed successfully!"));
    } catch (err) {
      dispatch(snackMessage(err.response ? err.response.data : err.message));
    }
    dispatch(Load());
    dispatch(openSnack());
  };
  return handleRefresh;
};
export default useRefresh;
